import { render, staticRenderFns } from "./NDrawer.vue?vue&type=template&id=06f225ff&scoped=true"
import script from "./NDrawer.vue?vue&type=script&lang=ts"
export * from "./NDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f225ff",
  null
  
)

export default component.exports